/*
 * Copyright (c) University of Technology Sydney. All rights reserved.
 * See LICENSE file in the project root for full license information.
 *
 * Project Name: wpt-frontend.
 * Author: Tim Porritt
 * Created: 21/12/21
 */

/**
 * Combine parts of url, placing slashes between each.
 * - Leading and trailing slashes are kept
 * @param parts
 * @returns {string} All parts joined with '/'
 */
export const joinPaths = (...parts: (string | number)[]): string => {
    const strParts = parts.map((p) => p.toString());

    if (strParts.length === 0) {
        return '';
    } else if (strParts.length === 1) {
        return strParts[0];
    }

    const startSlash = /^\/+/g;
    const endSlash = /\/+$/g;

    const [last, ...notLast] = strParts.reverse();
    const [first, ...middle] = notLast.reverse();

    const cleanedParts = [
        first.replace(endSlash, ''),
        ...middle.map((p) => p.replace(startSlash, '').replace(endSlash, '')).filter((p) => p),
        last.replace(startSlash, ''),
    ];

    return cleanedParts.join('/');
};
